import type { QueryResult } from '@apollo/client';
import type { GetMeQuery, GetMeQueryVariables } from 'generated/graphql';
import { createContext, useContext } from 'react';

export interface CurrentUserQueryContextValue {
  query: QueryResult<GetMeQuery, GetMeQueryVariables>;
  suspensePromise?: Promise<void>;
}

export const CurrentUserQueryContext = createContext<CurrentUserQueryContextValue | undefined>(
  undefined
);

CurrentUserQueryContext.displayName = 'CurrentUserQueryContext';

export function useCurrentUserQueryContext(): CurrentUserQueryContextValue {
  const context = useContext(CurrentUserQueryContext);

  if (context == null) {
    throw new Error('useCurrentUser must be used within CurrentUserProvider');
  }

  return context;
}
